var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AfterViewInit, ChangeDetectorRef, EventEmitter } from '@angular/core';
import { CacheConstants } from '../../../shared/cache-constants';
import { TvshopConstants } from '../../../shared/tvshop-constants';
import { ResourceService } from '../../../services/resource/resource.service';
import { OcapiService } from '../../../services/ocapi/ocapi.service';
import { PageNames } from '../../../shared/page-names.enum';
import { NavigationService } from '../../../services/navigation/navigation.service';
import { KeyDirections } from '../../../shared/key-directions.enum';
import { BaseActions } from '../../../shared/base-actions';
import { ModalConfig } from '../../../model/modal-config';
import { takeUntil } from 'rxjs/operators';
import { CacheService } from '@ngx-cache/core';
import { Order } from '../../../model/order';
import { Error } from '../../../model/error';
import { AnalyticsService } from '../../../services/analytics/analytics.service';
import { OmapiIdConstants } from '../../../shared/omapi-id-constants';
import { OmapiIdsUtils } from '../../../shared/utils/omapi-ids/omapi-ids-utils';
import { UserTypeConstants } from '../../../shared/user-type-constants';
import { OcapiSynchronousService } from '../../../services/ocapi/ocapi.synchronous.service';
import { OcapiAsynchronousService } from '../../../services/ocapi/ocapi.asynchronous.service';
import { TvShopStateService } from '../../../services/state/tv-shop-state.service';
var ModalComponent = /** @class */ (function (_super) {
    __extends(ModalComponent, _super);
    function ModalComponent(navigationService, changeDetector, pincodeService, ocapiService, ocapiSynchronousService, ocapiAsynchronousService, cacheService, resourceService, stateService, analyticsService) {
        var _this = _super.call(this) || this;
        _this.navigationService = navigationService;
        _this.changeDetector = changeDetector;
        _this.pincodeService = pincodeService;
        _this.ocapiService = ocapiService;
        _this.ocapiSynchronousService = ocapiSynchronousService;
        _this.ocapiAsynchronousService = ocapiAsynchronousService;
        _this.cacheService = cacheService;
        _this.resourceService = resourceService;
        _this.stateService = stateService;
        _this.analyticsService = analyticsService;
        _this.pincode = '';
        _this.pincodeIncorrect = false;
        _this.timeOut = false;
        _this.showHint = false;
        _this.emitOpenConditions = new EventEmitter();
        _this.emitOrderSucceeded = new EventEmitter();
        _this.emitOrderFailed = new EventEmitter();
        _this.emitOrderTimeOut = new EventEmitter();
        _this.emitOnBack = new EventEmitter();
        _this.componentName = PageNames.PINCODE_MODAL;
        _this.activationPending = false;
        return _this;
    }
    ModalComponent.prototype.ngAfterViewInit = function () {
        this.logoUrl = this.resourceService.getLogoUrl(this.order.packOmapiId, this.order.subPackOmapiId, this.order.type === Order.DAYPASS);
        this.navigationService.resetNavigation();
        this.pincodeIncorrect = false;
        this.getAndSetSuspentionInformation();
        this.changeDetector.detectChanges();
    };
    ModalComponent.prototype.pinReceived = function (event) {
        this.pincodeIncorrect = false;
        if (event && !isNaN(event.pin)) {
            this.pincode = this.pincode + event.pin;
            this.navigationService.navigate(KeyDirections.ARROW_RIGHT);
        }
        if (this.pincode.length === 4) {
            this.checkPincode();
        }
    };
    ModalComponent.prototype.pinRemoved = function () {
        this.pincode = this.pincode.slice(0, -1);
    };
    ModalComponent.prototype.toggleHint = function () {
        this.showHint = !this.showHint;
    };
    ModalComponent.prototype.onEmitOrderSucceeded = function () {
        this.emitOrderSucceeded.emit({
            omapiId: this.order.packOmapiId
        });
    };
    ModalComponent.prototype.onEmitOrderFailed = function (error) {
        this.emitOrderFailed.emit({
            omapiId: this.order.subPackOmapiId,
            error: error
        });
    };
    ModalComponent.prototype.onEmitOrderTimeOut = function () {
        this.emitOrderTimeOut.emit({
            omapiId: this.order.packOmapiId
        });
    };
    ModalComponent.prototype.onEmitOpenConditions = function () {
        this.emitOpenConditions.emit({
            omapiId: this.order.packOmapiId
        });
    };
    ModalComponent.prototype.checkPincode = function () {
        var _this = this;
        this.pincodeService.verifyPin(this.pincode)
            .pipe(takeUntil(this.stopSubscription)).subscribe(function (correctPin) {
            if (correctPin) {
                _this.correctPin();
            }
            else {
                _this.incorrectPin();
            }
        });
        this.analyticsService.onProductOrdered(this.order);
    };
    ModalComponent.prototype.incorrectPin = function () {
        this.pincodeIncorrect = true;
        this.pincode = '';
        this.navigationService.resetPage();
        this.getAndSetSuspentionInformation();
    };
    ModalComponent.prototype.correctPin = function () {
        var _this = this;
        this.pincodeIncorrect = false;
        this.activationPending = true;
        this.stateService.setIsOrderProcessPending(true);
        var activatePackObservable;
        if (this.stateService.selectSnapshot(function (state) { return state.isStreamingBundleOrder; }) || this.stateService.selectSnapshot(function (state) { return state.isStreamingServiceOrder; })) {
            activatePackObservable = this.stateService.activateStreamingService();
        }
        else {
            if (OmapiIdsUtils.currentUserType === UserTypeConstants.LEGACY_USER) {
                activatePackObservable = this.ocapiAsynchronousService.activatePack(this.order);
            }
            else if (OmapiIdsUtils.currentUserType === UserTypeConstants.DWN_USER) {
                activatePackObservable = this.ocapiSynchronousService.activatePack(this.order);
            }
        }
        var activatePack = activatePackObservable
            .pipe(takeUntil(this.stopSubscription))
            .subscribe(function (response) {
            _this.clearCache(CacheConstants.DTV_CATALOG);
            if (response.success) {
                _this.onEmitOrderSucceeded();
                _this.analyticsService.onOrderSucces(_this.order);
                _this.stopSubscription.next(true);
                _this.stateService.setIsOrderProcessPending(false);
            }
            else {
                _this.stateService.setIsOrderProcessPending(false);
                console.log('ERROR for action: ' + response.id + ', activating entertainment pack: ' + response.errorCode + ': ' + response.errorMessage);
                var error = new Error(response.errorCode, response.errorMessage);
                _this.onEmitOrderFailed(error);
            }
            _this.timeOut = false;
            _this.activationPending = false;
        }, function (err) {
            _this.stateService.setIsOrderProcessPending(false);
            console.log('ERROR for action: ' + err.id + ', activating entertainment pack: ' + err.errorCode + ': ' + err.errorMessage);
            var error = new Error(err.errorCode, err.errorMessage);
            _this.onEmitOrderFailed(error);
        });
        this.activateTimeOut(activatePack);
    };
    ModalComponent.prototype.activateTimeOut = function (activateContentPack) {
        var _this = this;
        setTimeout(function () {
            if (!_this.timeOut) {
                _this.activationPending = false;
                activateContentPack.unsubscribe();
                _this.onEmitOrderTimeOut();
                _this.clearCache(CacheConstants.DTV_CATALOG);
            }
        }, TvshopConstants.MAXIMUM_ORDERING_COOL_DOWN_IN_MS);
    };
    ModalComponent.prototype.getAndSetSuspentionInformation = function () {
        var _this = this;
        this.pincodeService.getRemainingAttempts().subscribe(function (numberOfTimeLeft) {
            _this.numberOfTimeLeft = numberOfTimeLeft;
            if (numberOfTimeLeft <= 0) {
                _this.pincodeService.getSuspensionExpiration().subscribe(function (value) {
                    _this.suspensionExpiration = value;
                    _this.suspension = true;
                    _this.navigationService.navigate(KeyDirections.ARROW_DOWN);
                });
            }
            else {
                _this.suspension = false;
            }
        });
    };
    ModalComponent.prototype.onBack = function () {
        document.activeElement.blur();
        this.emitOnBack.emit({
            value: true
        });
    };
    ModalComponent.prototype.clearCache = function (cacheConstants) {
        if (this.cacheService.has(cacheConstants.toString())) {
            this.cacheService.remove(cacheConstants.toString());
        }
    };
    ModalComponent.prototype.getPackageName = function () {
        return this.order.packOmapiId === OmapiIdConstants.RED_CARPET_MORE ? OmapiIdConstants.COM_NAME_RED_CARPET_MORE : this.order.orderName();
    };
    return ModalComponent;
}(BaseActions));
export { ModalComponent };
